import { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { UserContext } from 'app/context/UserContext/UserContext';
import { ChannelManager } from 'app/typings/channelManagers';
import { RateMode } from 'app/typings/rateModes';

export type InventoryPermissions = {
  isConnectedHotel: boolean;
  isAutomatedHotel: boolean;

  canEditStock: boolean;
  canEditPrice: boolean;
  canEditDiscountPrice: boolean;
  canEditStopSell: boolean;

  canAccessBulkEdit: boolean;
  canAccessAutoInventory: boolean;

  canForceUnpublish: boolean;
  canTogglePublished: boolean;
};

export const useInventoryPermissions = (): InventoryPermissions => {
  const { hotelInfo } = useContext(HotelContext);
  const { isAdmin } = useContext(UserContext);

  const { channelManager, rateMode, stockScrapperEnabled } = hotelInfo ?? {};

  const isConnectedHotel =
    !!channelManager && channelManager !== ChannelManager.NONE;

  const isAutomatedHotel = !!stockScrapperEnabled;

  const isExternallyManaged =
    isConnectedHotel && rateMode === RateMode.MULTI_RATE;

  return {
    isConnectedHotel,
    isAutomatedHotel,

    canEditStock: !isConnectedHotel,
    canEditPrice: !isExternallyManaged && !isConnectedHotel,
    canEditDiscountPrice: !isExternallyManaged,
    canEditStopSell: true,

    canAccessBulkEdit: !isExternallyManaged,
    canAccessAutoInventory: !isConnectedHotel,

    canForceUnpublish: isAdmin,
    canTogglePublished: isAdmin,
  };
};
